<template>
	<div class="bid">
		<!-- 顶部导航 -->
		<div class="nav">
			<van-icon name="arrow-left" color="#fff" size="1.2rem" @click="backTo" />
			<span>招标投标</span>
			<div></div>
		</div>
		<!-- 招标菜单 -->
		<van-tabs v-model="active" class='menu' @click="changes">
			<van-search class="search" shape="round" placeholder="请输入搜索关键词" v-model="value" />
			<van-tab :title="item.title" v-for="item in bidTitle" :name="item.id"></van-tab>
		</van-tabs>
		<div class="content" ref="wrapper">
			<van-list :finished="finished" v-model="loading" finished-text="系统开发中... 敬请期待！" @load="onLoad">
				<van-cell :title="item.title" size="large" :to="{path: '/bidDetail', query: {id: item.id}}" v-for="item in list">
					<div slot="label" class="menu_label">
						<van-icon name="clock-o" size="0.9rem" />
						<span>{{item.create_time}}</span>
					</div>
				</van-cell>
			</van-list>
		</div>
		<Footbar></Footbar>
	</div>
</template>

<script>
	import Footbar from '@/components/footbar'
	import Loding from '@/components/loding'

	export default {
		name: 'bid',
		data() {
			return {
				active: 0,
				value: '',
				list: [],
				bidTitle: [{
					id: 1,
					title: "招标信息"
				}, {
					id: 2,
					title: "中标信息"
				}],
				loading: false,
				finished: false,
				pages: 1,
				ids: 1,
				scroll: 0,
			}
		},
		beforeCreate() {},
		components: {
			Footbar,
			Loding
		},
		created() {
			//获取导航栏信息 招标信息-中标信息-在线投标
			// this.$axios.post(baseUrl + '/mobile/Base/bidTitle').then((res) => {
			// 	if (res.data.code == 2) {
			// 		this.bidTitle = res.data.data;
			// 	}
			// }).catch((err) => {
			// 	console.log(err);
			// });
		},
		methods: {
			//获取信息列表
			getData(id) {
				this.loading = true;
				this.finished = false;
				this.ids = id;
				this.pages = 1;
				this.list = [];
				this.$axios.post(baseUrl + '/mobile/Base/bid', {
					id: this.ids,
					limit: 10,
					page: this.pages
				}).then((res) => {
					if (res.data.code == 2) {
						this.pages++;
						setTimeout(() => {
							for (var i in res.data.data) {
								this.list.push(res.data.data[i]);
							}
							// 加载状态结束
							this.loading = false;
						}, 500)
					} else {
						this.loading = false;
						this.finished = true;
					}
				}).catch((err) => {
					console.log(err);
				});
			},
			onLoad() {
				this.$axios.post(baseUrl + '/mobile/Base/bid', {
					id: this.ids,
					limit: 10,
					page: this.pages
				}).then((res) => {
					if (res.data.code == 2) {
						this.pages++;
						setTimeout(() => {
							for (var i in res.data.data) {
								this.list.push(res.data.data[i]);
							}
							// 加载状态结束
							this.loading = false;
						}, 500)
					} else {
						this.loading = false;
						this.finished = true;
					}
				}).catch((err) => {
					console.log(err);
				});
			},
			//切换
			changes(name) {
				this.getData(name);
			},
			backTo() {
				this.$router.push('/')
			},
		},
		beforeRouteLeave(to, from, next) {
			//获取滚动
			let position = this.$refs.wrapper.scrollTop;
			console.log(position)
			if (position == null) position = 0
			this.$store.commit('changeRecruitScrollY', position) //离开路由时把位置存起来
			next()
		},
		watch: {
			'$route'(to, from) {
				console.log(to)
				console.log("1111")
				if (to.name === 'bid') { //跳转的的页面的名称是"NewRecruit",这里就相当于我们listview页面，或者原始页面
					let recruitScrollY = this.$store.state.recruitScrollY
					console.log(recruitScrollY)
					this.$refs.wrapper.scrollTop = recruitScrollY
				}
			}
		},
	}
</script>

<style scoped>
	@import 'bid.css';

	.bid .tips button {
		margin-top: 1rem;
	}
</style>



// WEBPACK FOOTER //
// src/components/home/bid.vue